import { useEffect, useRef } from 'react';
import useStoreAuth from 'src/hooks/useStoreAuth';
import { UserProfileDropdown } from 'src/layouts/dashboard/header/user-menu/UserProfileDropdown';

import { readTaxModuleEnabled } from '@hooks/_taxModule';
import { ME_INCLUDE, useMe } from '@hooks/users';
import useStoreAppConfig from '@hooks/useStoreAppConfig';
import { getWeekStart } from '@utils/userConfig';

export function QuickUserToggler(props) {
  const [auth, { setAuth, setUserConfig }] = useStoreAuth();
  const [, { setHotelChain }] = useStoreAppConfig();

  const authRef = useRef(auth);
  authRef.current = auth;

  const { normalizedData: user, isFetching } = useMe({ include: ME_INCLUDE });

  useEffect(() => {
    if (!user) return;

    setAuth({ ...authRef.current, scopes: user.profile.scopes, role: user.profile.role });
    setUserConfig({
      userId: user.id,
      usersGridConfig: user.usersGridConfig,
      segmentationTypes: user.segmentationTypes ?? [],
      weekStart: getWeekStart(user.config),
    });

    setHotelChain({
      hotelChainId: user.profile.hotelChain.id,
      name: user.profile.hotelChain.name,
      slug: user.profile.hotelChain.slug,
      orderPrefix: user.profile.hotelChain.orderPrefix,
      taxModuleEnabled: readTaxModuleEnabled(user.profile.hotelChain),
      hotels: user.profile.hotelChain.hotels.map((hotel) => ({
        hotel: hotel.id,
        hotelName: hotel.name,
        hotelSlug: hotel.slug,
        hotelLogo: hotel.logoPositive,
      })),
    });
  }, [user, setAuth, setUserConfig, setHotelChain]);

  return <UserProfileDropdown {...props} loading={isFetching} user={user} />;
}
